import React, { useCallback } from 'react';
import { Card, Form } from 'react-bootstrap';

import { useFormikContext } from 'formik';

import { updateQueryStringOnFieldChange } from '@components/Filters/Filters';
import { useThrottle } from '@features/useThrottle';
import { countryApi } from '@reducers/geo';
import { planApi } from '@reducers/plan/plan';
import { skipToken } from '@reduxjs/toolkit/query';

export const DedicatedChannelsFilter = ({ searchParams, setSearchParams }) => {
  const { handleChange, handleBlur, values } = useFormikContext();
  const countries = countryApi.useGetForSelectQuery();
  const plans = planApi.useGetForSelectQuery(
    values.country ? { id: values.country } : skipToken
  );

  const throttle = useThrottle((event) => {
    updateQueryStringOnFieldChange(event, { searchParams, setSearchParams });
  }, 500);
  const throttledChangeHandler = useCallback(
    (event) => {
      handleChange(event);
      throttle(event);
    },
    [throttle]
  );
  return (
    <Card>
      <Card.Header className="bg-didxl text-white">Search form</Card.Header>
      <Card.Body>
        <Form.Group className="mb-3" controlId="formGroupCountry">
          <Form.Label>Country</Form.Label>
          <Form.Select
            name="country"
            size="sm"
            value={values.country}
            onChange={(e) => {
              handleChange(e);
              updateQueryStringOnFieldChange(e, {
                clearFields: ['plan'],
                searchParams,
                setSearchParams,
              });
            }}
            onBlur={handleBlur}
          >
            <option value="">Select country</option>
            {!countries.isLoading &&
            !countries.isError &&
            countries.data.length > 0 ? (
              <>
                {countries.data.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </>
            ) : null}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formPlanFilterID">
          <Form.Label>Plan</Form.Label>
          <Form.Select
            className="mb-3"
            name="plan"
            size="sm"
            value={values.plan}
            disabled={plans.isLoading || plans.isFetching || !values.country}
            onChange={(e) => {
              handleChange(e);
              updateQueryStringOnFieldChange(e, {
                searchParams,
                setSearchParams,
              });
            }}
            onBlur={handleBlur}
          >
            <option value="">
              {values.country ? 'Select plan' : 'Select country to see plans'}
            </option>
            {!plans.isUninitialized &&
            !plans.isLoading &&
            !plans.isError &&
            plans.data.length > 0 ? (
              <>
                {plans.data.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </>
            ) : null}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formGroupDid">
          <Form.Label>DID Number</Form.Label>
          <Form.Control
            type="input"
            name="did"
            size="sm"
            value={values.did}
            onChange={throttledChangeHandler}
            onBlur={handleBlur}
          />
        </Form.Group>
      </Card.Body>
    </Card>
  );
};
